<div class="modal-overlay" (click)="onClose()">
    <div class="modal-container" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h2 class="modal-title">{{ rule ? 'Modifier la règle' : 'Nouvelle règle' }}</h2>
            <button class="close-btn" (click)="onClose()">×</button>
        </div>

        <form [formGroup]="ruleForm" (ngSubmit)="onSubmit()" class="modal-body">
            <div class="form-group">
                <label for="name">NOM DE LA RÈGLE</label>
                <input type="text" id="name" formControlName="name" class="form-control"
                    placeholder="ex: Règle Standard">
            </div>

            <div class="dialog-grid">
                <!-- Column 1: Thresholds (explicit Bas/Haut) -->
                <div class="grid-column">
                    <label style="margin-bottom: 0.5rem; color: #1e293b; font-weight: 600;">LOGIQUE DE DÉDUCTION</label>

                    <div class="threshold-section"
                        style="background: #f1f5f9; padding: 1rem; border-radius: 8px; margin-bottom: 1rem;">
                        <div
                            style="font-weight: 600; font-size: 11px; color: #475569; margin-bottom: 0.5rem; text-transform: uppercase;">
                            Seuil Bas (BT si en dessous)</div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 0.5rem;">
                            <div class="form-group" style="margin-bottom: 0;">
                                <label style="font-size: 10px;">TENSION (kV)</label>
                                <input type="number" formControlName="minTension" class="form-control compact-input"
                                    placeholder="10">
                            </div>
                            <div class="form-group" style="margin-bottom: 0;">
                                <label style="font-size: 10px;">P >= (kVA)</label>
                                <input type="number" formControlName="minPuissance" class="form-control compact-input"
                                    placeholder="800">
                            </div>
                        </div>
                    </div>

                    <div class="threshold-section" style="background: #eff6ff; padding: 1rem; border-radius: 8px;">
                        <div
                            style="font-weight: 600; font-size: 11px; color: #2563eb; margin-bottom: 0.5rem; text-transform: uppercase;">
                            Seuil Haut (HT si au dessus)</div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 0.5rem;">
                            <div class="form-group" style="margin-bottom: 0;">
                                <label style="font-size: 10px;">TENSION (kV)</label>
                                <input type="number" formControlName="maxTension" class="form-control compact-input"
                                    placeholder="20">
                            </div>
                            <div class="form-group" style="margin-bottom: 0;">
                                <label style="font-size: 10px;">P > (kVA)</label>
                                <input type="number" formControlName="maxPuissance" class="form-control compact-input"
                                    placeholder="1250">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Column 2: Voltage choices -->
                <div class="grid-column">
                    <div
                        style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.5rem;">
                        <label style="margin-bottom: 0; color: #1e293b; font-weight: 600;">LISTE TENSIONS</label>
                        <button type="button" class="btn btn-xs btn-outline" (click)="addVoltageOption()">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                    <div class="table-responsive table-scroll">
                        <table class="modern-table">
                            <tbody formArrayName="voltageOptions">
                                @for (_ of voltageOptions.controls; track $index) {
                                <tr>
                                    <td><input type="text" [formControlName]="$index" class="form-control compact-input"
                                            placeholder="ex: 20 kV"></td>
                                    <td class="action-cell">
                                        <button type="button" class="btn-icon delete"
                                            (click)="removeVoltageOption($index)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Column 3: Power choices -->
                <div class="grid-column">
                    <div
                        style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.5rem;">
                        <label style="margin-bottom: 0; color: #1e293b; font-weight: 600;">LISTE PUISSANCES</label>
                        <button type="button" class="btn btn-xs btn-outline" (click)="addPuissanceOption()">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                    <div class="table-responsive table-scroll">
                        <table class="modern-table">
                            <tbody formArrayName="puissanceOptions">
                                @for (_ of puissanceOptions.controls; track $index) {
                                <tr>
                                    <td><input type="text" [formControlName]="$index" class="form-control compact-input"
                                            placeholder="ex: 1250 KVA"></td>
                                    <td class="action-cell">
                                        <button type="button" class="btn-icon delete"
                                            (click)="removePuissanceOption($index)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="form-group checkbox-group"
                style="display: flex; align-items: center; gap: 0.5rem; margin-top: 0.5rem;">
                <input type="checkbox" id="active" formControlName="active" style="width: auto;">
                <label for="active" style="margin-bottom: 0;">Activer cette règle immédiatement</label>
            </div>

            <div class="modal-footer">
                <div class="modal-footer-left">
                    @if (rule?.id) {
                    <button type="button"
                        class="btn"
                        [class.btn-danger-outline]="deleteCanProceed()"
                        [class.btn-warning-outline]="!deleteCanProceed()"
                        (click)="onDeleteClick()"
                        [disabled]="isSubmitting">
                        {{ deleteCanProceed() ? 'Supprimer' : 'Archiver' }}
                    </button>
                    }
                </div>
                <div class="modal-footer-right">
                    <button type="button" class="btn btn-outline" (click)="onClose()">Annuler</button>
                    <button type="submit" class="btn btn-primary" [disabled]="ruleForm.invalid || isSubmitting">
                        {{ isSubmitting ? 'Enregistrement...' : (rule ? 'Enregistrer' : 'Créer la règle') }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>

@if (showDeleteConfirm()) {
<app-confirmation-dialog
  [dialogTitle]="deleteCanProceed() ? 'Supprimer la règle' : 'Archiver la règle'"
  [message]="deleteCanProceed()
    ? 'Voulez-vous vraiment supprimer la règle \'' + rule!.name + '\' ? Cette action est irréversible.'
    : 'Cette règle est active et ne peut pas être supprimée. Voulez-vous l\'archiver à la place ?'"
  [confirmLabel]="deleteCanProceed() ? 'Supprimer' : 'Archiver'"
  cancelLabel="Annuler"
  [isDanger]="deleteCanProceed()"
  [isWarning]="!deleteCanProceed()"
  (confirm)="confirmDelete()"
  (cancel)="cancelDelete()">
</app-confirmation-dialog>
}
